/**
 * Shared form-field styling.
 *
 * Chrome paints its own background on autofilled inputs. That paint stops at
 * the `input` element, so it never covers an end adornment (a password
 * visibility toggle, say) and the field ends up looking like two boxes.
 * Repainting it with an inset shadow keeps the field one piece.
 *
 * Pair this with `InputLabelProps={{ shrink: true }}`: browsers fill saved
 * credentials straight into the DOM without firing React's onChange, so a
 * controlled field still believes it is empty and leaves the floating label
 * sitting on top of the value.
 */
export const AUTOFILL_SX = {
  "& input:-webkit-autofill, & input:-webkit-autofill:focus": {
    WebkitBoxShadow: "0 0 0 100px #ffffff inset",
    WebkitTextFillColor: "rgba(0, 0, 0, 0.87)",
    caretColor: "rgba(0, 0, 0, 0.87)",
    borderRadius: "inherit",
  },
};

export default AUTOFILL_SX;
